import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import "../../Styles/Firstcard.css";
import "../../Styles/ViewFeeStructure.css"; 
import { simplePostCall } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import ScaleLoader from "react-spinners/ScaleLoader";
import { Printer, Edit, Trash2, ChevronUp } from 'lucide-react';

export default function Firstcard() {
  const [feeCategories, setFeeCategories] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedClass, setSelectedClass] = useState(null);
  const { yearID } = useParams();

  useEffect(() => {
    loadDataStudentFee();
  }, [yearID]);

  const loadDataStudentFee = async () => {
    setIsLoading(true);
    const customer_id = localStorage.getItem("customer_id");
    const api_key = localStorage.getItem("api_key");
    const requestBody = {
      customer_id: Number(customer_id),
      api_key: api_key,
      academic: "cay25", 
    };
    try {
      const response = await simplePostCall(ApiConfig.feeStructurecatogorylist, JSON.stringify(requestBody));
      if (response?.result && response?.data) {
        setFeeCategories(response.data);
      } else {
        setFeeCategories([]);
      }
    } catch (error) {
      setFeeCategories([]);
    } finally {
      setIsLoading(false);
    }
  };

  if (selectedClass) {
    return (
      <div className="vfs-main-container">
        <div className="vfs-white-header-row">
          <h1 className="vfs-page-title">View Fee Structure</h1>
          <div className="vfs-header-actions">
            <div className="vfs-display-header-box">
              <span className="vfs-header-label">Display Header</span>
              <input type="checkbox" defaultChecked className="vfs-header-checkbox" />
            </div>
            <button className="FS-btn-common FS-btn-print-color">
               Print <Printer size={16}/>
             </button>
             
             <button className="FS-btn-common FS-btn-edit-color">
               Edit
             </button>
             
             <button className="FS-btn-common FS-btn-delete-color">
               Delete
             </button>
                     </div>
                   </div>
                   

        <div className="vfs-inner-card">
          <table className="vfs-info-table">
            <tbody>
              <tr>
                <td className="vfs-td-label">Grade Name</td>
                <td className="vfs-td-value">{selectedClass.class_name}</td>
              </tr>
              <tr>
                <td className="vfs-td-label">Academic Year Name</td>
                <td className="vfs-td-value">{yearID}</td>
              </tr>
            </tbody>
          </table>

          <div className="vfs-summary-container">
            <div className="vfs-summary-title">Summary</div>
            <div className="vfs-summary-content">
              <span className="vfs-amount-text">Annual Total Amount(₹)</span>
              <span className="vfs-amount-value">₹ {selectedClass.amount.toLocaleString()}</span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="firstcard-container my-4">
      <div className="special-header d-flex justify-content-between mb-4">
        <h4 className="page-title mt-2">Academic Year: {yearID}</h4>
        <Link to="/create-fee" className="btn custom-btn pt-2">Create</Link>
      </div>

      <div className="row fee-struc">
        {isLoading ? (
          <div className="col-12 text-center">
            <ScaleLoader color="#F4BB44" />
            <p className="mt-2">Fetching classes for {yearID}...</p>
          </div>
        ) : feeCategories.length > 0 ? (
          feeCategories.map((item, index) => (
            <div className="col-md-12 col-lg-4 col-sm-12 mb-4" key={index}>
              <div className={`card ${index % 2 === 0 ? "kard1" : "kard2"} text-center`}>
                <div className="card-body">
                  <h5 className="card-title"><b>{item.class_name}</b></h5>
                  <p className="card-text">Total Fee: ₹{item.amount.toLocaleString()}</p>
                  <button 
                    className="btn" 
                    style={{fontSize: "13px", padding: "6px 12px", display: "inline-flex", alignItems: "center", gap: "6px"}}
                    onClick={() => setSelectedClass(item)}
                  >
                    <i className="bi bi-arrow-up-right-square-fill"></i> View
                  </button>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="col-12 text-center">
            <p>No data found for the year {yearID}.</p>
          </div>
        )}
      </div>
    </div>
  );
}